module.exports = __webpack_public_path__ + "img/ic_Jcb.75d6397f.svg";